<template>
    <div class="AddLegislationBox">
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/legislation' }">法律、法规和标准</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? "编辑" : "新增" }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small"
                     style="width: 60%;marginLeft: 15%" label-width="120px">
                <el-form-item label="上传文件" prop="uploadFile">
                    <el-upload
                            class="upload-demo"
                            drag
                            action="/v1/lawsRegulations/uploadFile"
                            :on-change="handleChange"
                            :on-exceed="handleExceed"
                            :limit="1"
                            :file-list="fileList"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="文件名称" prop="fileName">
                    <el-input v-model="ruleForm.fileName"/>
                </el-form-item>
                <el-form-item label="法规编号" prop="number">
                    <el-input v-model="ruleForm.number"/>
                </el-form-item>
                <el-form-item label="分类" prop="type">
                    <el-select v-model="ruleForm.type">
                        <el-option v-for="item in typeList" :key="item.id" :value="item.id" :label="item.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="强制程度" prop="constraintDegree">
                    <el-radio-group v-model="ruleForm.constraintDegree" size="small">
                        <el-radio-button :label="1">强制性</el-radio-button>
                        <el-radio-button :label="2">推荐性</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发布机构" prop="issueOrganization">
                    <el-input v-model="ruleForm.issueOrganization"/>
                </el-form-item>
                <el-form-item label="发布日期" prop="issueTime">
                    <el-date-picker v-model="ruleForm.issueTime" type="date" placeholder="选择日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"/>
                </el-form-item>
                <el-form-item label="启用日期" prop="activeTime">
                    <el-date-picker v-model="ruleForm.activeTime" type="date" placeholder="选择日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"/>
                </el-form-item>
                <el-form-item label="废止日期" prop="abolishTime">
                    <el-date-picker v-model="ruleForm.abolishTime" type="date" placeholder="选择日期"
                                    value-format="yyyy-MM-dd HH:mm:ss"/>
                </el-form-item>
                <el-form-item label="摘要" prop="digest">
                    <el-input v-model="ruleForm.digest" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="现行法规" prop="isUsing">
                    <el-radio-group v-model="ruleForm.isUsing" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label-width="0" style="marginBottom: 0px">
                    <el-col :span="12">
                        <el-form-item label="复查人" prop="assessmentEmpId">
                            <el-select v-model="ruleForm.assessmentEmpId" @change="assChange" style="width: 100%">
                                <el-option v-for="item2 in userList" :key="item2.id" :label="item2.name"
                                           :value="item2.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排查日期" prop="assessmentTime">
                            <el-date-picker v-model="ruleForm.assessmentTime" type="date" placeholder="选择日期"
                                            value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"/>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label-width="0">
                    <el-col :span="12">
                        <el-form-item label="辨识人" prop="identifyEmpId">
                            <el-select v-model="ruleForm.identifyEmpId" style="width: 100%" @change="indentifyChange">
                                <el-option v-for="item3 in userList" :key="item3.id" :label="item3.name"
                                           :value="item3.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="辨识日期" prop="identifyTime">
                            <el-date-picker v-model="ruleForm.identifyTime" type="date" placeholder="选择日期"
                                            value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"/>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {getEmpBindUser, lawsRegulationsEdit, lawsRegulationsAdd} from "@/api/processManager"

    export default {
        name: 'AddLegislation',
        data() {
            var checkFile = (rule, value, callback) => {
                if (this.fileList.length === 0) {
                    callback(new Error('请上传文件'));
                }
                callback();
            }
            return {
                ruleForm: {},
                fileList: [],
                userList: [],
                rules: {
                    uploadFile: [{required: true, validator: checkFile, trigger: 'change'}],
                    fileName: [{required: true, message: '文件名称'}],
                    number: [{required: true, message: '法规编号'}],
                    type: [{required: true, message: '分类', trigger: 'change'}],
                    constraintDegree: [{required: true, message: '强制程度'}],
                    issueOrganization: [{required: true, message: '发布机构'}],
                    issueTime: [{required: true, message: '发布日期'}],
                    activeTime: [{required: true, message: '启用日期'}],
                    // abolishTime: [{ required: true, message: '废止日期' }],
                    digest: [{required: true, message: '摘要'}],
                    isUsing: [{required: true, message: '现行法规'}],
                    assessmentEmpId: [{required: true, message: '复查人'}],
                    assessmentTime: [{required: true, message: '排查日期'}],
                    identifyEmpId: [{required: true, message: '辨识人'}],
                    identifyTime: [{required: true, message: '辨识日期'}],
                },
                typeList: [
                    {id: 1, name: '法律法规'}, {id: 2, name: '行政法规'}, {id: 3, name: '地方性法规'},
                    {id: 4, name: '部门规章'}, {id: 5, name: '标准与规范'}, {id: 6, name: '废止法律法规'},
                    {id: 7, name: '其它'}
                ]
            }
        },
        async created() {
            await getEmpBindUser().then(res => {
                this.userList = res.body.data
            })
            if (this.$route.params.key) {
                this.ruleForm = {...this.$route.params.key}
                if (this.ruleForm.filePath) {
                    this.fileList.push({
                        name: this.ruleForm.fileName,
                        response: {data: this.ruleForm.filePath}
                    })
                }
            }
        },
        methods: {
            // 上传的事件
            handleChange(file, fileList) {
                this.fileList = fileList
                // this.ruleForm.fileName = file.name
                this.$set(this.ruleForm, 'fileName', file.name)
                if (file.response && file.response.data) {
                    this.ruleForm.filePath = file.response.data
                } else {
                    this.ruleForm.filePath = 'null'
                }
                this.$refs['ruleForm'].clearValidate();
            },
            handleExceed(file, fileList) {
                this.$message.warning('限制上传一个文件')
            },
            // 复查人改变
            assChange(id) {
                let obj = {}
                obj = this.userList.find((item) => {
                    return item.id === id
                })
                this.ruleForm.assessmentUser = obj.name
            },
            // 辨识人改变
            indentifyChange(id) {
                let obj = {}
                obj = this.userList.find((item) => {
                    return item.id === id
                })
                this.ruleForm.identifyUser = obj.name
            },
            // 保存
            submit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        // 编辑
                        if (this.$route.params.key) {
                            lawsRegulationsEdit({...this.ruleForm}).then(res => {
                                this.$message.success('编辑成功')
                                this.$router.push('legislation')
                            })
                        }
                        // 新增
                        else {
                            lawsRegulationsAdd({...this.ruleForm}).then(res => {
                                this.$message.success('新增成功')
                                this.$router.push('legislation')
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>

</style>
